import React, { FunctionComponent, FocusEvent, KeyboardEvent } from 'react';
import clsx from 'clsx';
import NumberFormat, { NumberFormatValues } from 'react-number-format';
import { Typography } from '../Typography/Typography';
import { TextField } from '../form/TextField/TextField';
import { TextFieldSize } from '../form/TextField/tools/TextField.const';

import useStyles from './CurrencyInput.style';

export const CurrencyInput: FunctionComponent<{
  value?: number;
  onValueChange: (value: number) => void;
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
  isAllowed?: (values: NumberFormatValues) => boolean;
  id?: string;
  required?: boolean;
  size?: TextFieldSize;
  hasError?: boolean;
  error?: string;
  className?: string;
}> = ({value, onValueChange, onFocus, onBlur, isAllowed, id, required = false, size = TextFieldSize.DEFAULT, hasError = false, error, className}) => {

  const classes = useStyles({});
  const combinedIsAllowed = (values: NumberFormatValues) => {
    if (typeof values.floatValue === 'number' && values.floatValue < 0) return false;
    if (isAllowed) return isAllowed(values);
    return true;
  };

  return (
    <NumberFormat
        className={clsx(classes.root, className)}
        customInput={TextField}
        size={size}
        label=""
        endAdornment={<Typography component="span" className={classes.currencySuffix}>PLN</Typography>}
        InputProps={{
          inputProps: {
            'aria-describedby': id ? `${id}-error` : undefined,
            'aria-required': required,
          },
        }}
        placeholder="0,00"
        value={value}
        id={id}
        decimalSeparator=","
        decimalScale={2}
        thousandSeparator=" "
        fixedDecimalScale={true}
        onValueChange={values => onValueChange(values.floatValue || 0)}
        onFocus={onFocus}
        onBlur={onBlur}
        isAllowed={combinedIsAllowed}
        allowNegative={false}
        error={error}
        onKeyDown={(event: KeyboardEvent<HTMLInputElement>) => event.key === '-' && event.preventDefault()}/>
  );
};
